var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReshareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333496 6.99992C0.333496 10.6818 3.31826 13.6666 7.00016 13.6666C10.682 13.6666 13.6668 10.6818 13.6668 6.99992C13.6668 3.31802 10.682 0.333252 7.00016 0.333252V1.66659C9.9457 1.66659 12.3335 4.0544 12.3335 6.99992C12.3335 9.94545 9.9457 12.3333 7.00016 12.3333C4.05464 12.3333 1.66683 9.94545 1.66683 6.99992C1.66683 5.16673 2.59172 3.54957 4.00032 2.58959L4.00016 4.33325H5.3335V0.333252H1.3335V1.66659L2.99962 1.66651C1.38066 2.88281 0.333496 4.81907 0.333496 6.99992Z",
    fill: "#0099CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshareIcon);
export default __webpack_public_path__ + "static/media/reshareIcon.d7ab522dd503d4943392f8cf82758da5.svg";
export { ForwardRef as ReactComponent };